import type React from 'react';
import { useState } from 'react';

import * as styles from './styles';

import { type AccessibleFleet, Location, type UUID } from '@cobliteam/common-types';

import { ChevronIcon, MenuItem, MenuItemType, Popper, VehicleGroupIcon } from '@cobliteam/base-components';

import { SidebarItemDropdownEntry } from '../SidebarItemDropdownEntry/SidebarItemDropdownEntry';
import Icon from '@cobliteam/ui/icons';

export interface SidebarFleetProps {
  accessibleFleets: AccessibleFleet[];
  changeUserFleet: (fleet: AccessibleFleet) => void;
  currentFleetId: UUID | false;
}

export const SidebarFleet: React.FC<SidebarFleetProps> = ({ accessibleFleets, changeUserFleet, currentFleetId }) => {
  const [popperHover, setPopperHover] = useState(false);
  const [transitionGuard, setTransitionGuard] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isActive, setIsActive] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setIsActive(true);
    setTransitionGuard(true);
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setIsActive(false);
    setTransitionGuard(false);
  };

  const handlePopperMouseLeave = () => {
    setPopperHover(false);
    setTransitionGuard(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, fleet: AccessibleFleet) => {
    event.preventDefault();

    changeUserFleet(fleet);

    handlePopperMouseLeave();
  };

  const renderFleetEntry = (fleet: AccessibleFleet) => (
    <SidebarItemDropdownEntry onClickCapture={(event) => handleClick(event, fleet)} location={Location.MONITORING} active={currentFleetId === fleet.id} key={fleet.id}>
      {fleet.name}
      <div className={styles.fleetSelectedIcon(true)}>{currentFleetId === fleet.id && <Icon name='check' />}</div>
    </SidebarItemDropdownEntry>
  );

  const sortedAccessibleFleets = accessibleFleets.sort((a, b) => a.name.localeCompare(b.name));

  const showAccessibleFleetsPopper = popperHover || transitionGuard;

  return (
    <>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={styles.sidebarItem}>
        <div className={styles.iconWrapper(isActive)}>
          <VehicleGroupIcon />
        </div>
        <MenuItem active={isActive} type={MenuItemType.LIGHT}>
          Trocar de frota
          <div className={styles.iconWrapper(isActive)}>
            <ChevronIcon />
          </div>
        </MenuItem>
      </div>
      {showAccessibleFleetsPopper && (
        <Popper
          open
          arrow={false}
          placement='right'
          paperClassName={styles.popper}
          handleMouseEnter={() => {
            setPopperHover(true);
            setTransitionGuard(true);
          }}
          handleMouseLeave={handlePopperMouseLeave}
          anchorEl={anchorEl}
          modifiers={[{ positionFixed: true }]}
        >
          {sortedAccessibleFleets.map(renderFleetEntry)}
        </Popper>
      )}
    </>
  );
};
